var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isRecurrenceException && !_vm.isReadOnly
        ? _c("RepeatFreqInterval", {
            attrs: {
              frequency: _vm.recurrenceRule.frequency,
              interval: _vm.recurrenceRule.interval
            },
            on: {
              changeInterval: _vm.changeInterval,
              changeFrequency: _vm.changeFrequency
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isFreqWeekly && !_vm.isRecurrenceException && !_vm.isReadOnly
        ? _c("RepeatFreqWeeklyOptions", {
            attrs: { "by-day": _vm.recurrenceRule.byDay },
            on: { addByDay: _vm.addByDay, removeByDay: _vm.removeByDay }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isFreqMonthly && !_vm.isRecurrenceException && !_vm.isReadOnly
        ? _c("RepeatFreqMonthlyOptions", {
            attrs: {
              "by-day": _vm.recurrenceRule.byDay,
              "by-month-day": _vm.recurrenceRule.byMonthDay,
              "by-set-position": _vm.recurrenceRule.bySetPosition
            },
            on: {
              addByMonthDay: _vm.addByMonthDay,
              removeByMonthDay: _vm.removeByMonthDay,
              changeByDay: _vm.setByDay,
              changeBySetPosition: _vm.setBySetPosition,
              changeToBySetPosition: _vm.changeToBySetPositionMonthly,
              changeToByDay: _vm.changeToByDayMonthly
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isFreqYearly && !_vm.isRecurrenceException && !_vm.isReadOnly
        ? _c("RepeatFreqYearlyOptions", {
            attrs: {
              "by-day": _vm.recurrenceRule.byDay,
              "by-month": _vm.recurrenceRule.byMonth,
              "by-set-position": _vm.recurrenceRule.bySetPosition
            },
            on: {
              changeByDay: _vm.setByDay,
              changeBySetPosition: _vm.setBySetPosition,
              addByMonth: _vm.addByMonth,
              removeByMonth: _vm.removeByMonth,
              enableBySetPosition: _vm.enableBySetPositionYearly,
              disableBySetPosition: _vm.disableBySetPositionYearly
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isRepeating && !_vm.isRecurrenceException && !_vm.isReadOnly
        ? _c("RepeatEndRepeat", {
            attrs: {
              "calendar-object-instance": _vm.calendarObjectInstance,
              until: _vm.recurrenceRule.until,
              count: _vm.recurrenceRule.count
            },
            on: {
              setInfinite: _vm.setInfinite,
              setUntil: _vm.setUntil,
              setCount: _vm.setCount,
              changeToCount: _vm.changeToCount,
              changeToUntil: _vm.changeToUntil
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isReadOnly
        ? _c("RepeatSummary", {
            attrs: { "recurrence-rule": _vm.recurrenceRule }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isReadOnly
        ? _c("RepeatSummaryReadOnly", {
            attrs: { "recurrence-rule": _vm.recurrenceRule }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.recurrenceRule.isUnsupported && !_vm.isRecurrenceException
        ? _c("RepeatUnsupportedWarning")
        : _vm._e(),
      _vm._v(" "),
      _vm.isRecurrenceException ? _c("RepeatExceptionWarning") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }